export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8324.f75b0b56.jpg";